//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    blankVisible:{
      type:Boolean,
      default:false
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {},
}
